import { combineReducers } from 'redux';

import general from './general';

import users from './users';
import user from './user';

import companies from './companies';
import company from './company';

import branch from './branch';
import branches from './branches';

import settings from './settings';

import personnels from './personnels';
import personnel from './personnel';

import accidents from './accidents';
import accident from './accident';

import event from './event';
import events from './events';

import hazard from './hazard';
import hazards from './hazards';

import courses from './courses';
import course from './course';

export default combineReducers({
  companies,
  company,
  general,
  branches,
  branch,
  users,
  user,
  settings,
  personnels,
  personnel,
  accidents,
  accident,
  events,
  event,
  hazards,
  hazard,
  courses,
  course
});
